import { watch, ref } from 'vue';

export function useAutoSave(getValue, saveFunction, validateFunction, delay = 1000) {
  const isSaving = ref(false);
  const saveSuccessful = ref(false);
  const lastSavedValue = ref("");
  
  // Create a debounced version of the save function
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
  
  const debouncedSave = debounce(async () => {
    // Only auto-save if value is valid and different from last saved
    const currentValue = getValue();
    if (validateFunction() && currentValue !== lastSavedValue.value) {
      isSaving.value = true;
      saveSuccessful.value = false;
      
      try {
        await saveFunction();
        lastSavedValue.value = currentValue;
        saveSuccessful.value = true;
        
        // Show success message for 2 seconds then hide it
        setTimeout(() => {
          saveSuccessful.value = false;
        }, 2000);
      } catch (error) {
        console.error("Auto-save failed:", error);
      } finally {
        isSaving.value = false;
      }
    }
  }, delay);
  
  // Setup the watcher
  function setupAutoSave(watchSource) {
    watch(watchSource, debouncedSave);
  }
  
  return {
    isSaving,
    saveSuccessful,
    lastSavedValue,
    setupAutoSave,
    updateLastSaved: (value) => { lastSavedValue.value = value; }
  };
}